

















import { Component, Vue } from "vue-property-decorator";
import ErrorCard from "@/components/error/ErrorCard.vue";

@Component({
    components: { ErrorCard }
})
export default class NotFound extends Vue {}
